module.exports = __webpack_public_path__ + "15a3f9262292f9a06f745e0864d01b6b.pdf";